
<div>
  <div class="modal-header {{bgHeader}}" style="padding: 1rem !important;">
      <span class="modal-title">{{ title }}</span>
  </div>
  <div class="modal-body">
    <span [innerHTML]="message"></span>
  </div>
</div>
